$(function () {
  function preloader() {
    if ($('.preloader').length) {
      $('.preloader').delay(100).fadeOut(400, function () {});
    }
  }
  $(window).on('load', function() {
    preloader();
  });
})



// WEBPACK FOOTER //
// ./src/assets/load.js